import Image from "../../../assets/images/community_hub.png";
import { RiTwitterXLine } from "react-icons/ri";
import { BiLogoTelegram } from "react-icons/bi";
import { AiOutlineMedium } from "react-icons/ai";

export default function Section9() {
  return (
    <section className="relative z-10 w-full flex flex-col items-center justify-center mb-[80px] md:mb-[130px] lg:mb-[150px]">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 w-full gap-8">
          <div className="bg-black text-white flex flex-col">
            <h2 className="text-[50px] font-normal text-white tracking-tight mb-6">
              Community Hub
            </h2>
            <p className="text-[18px] text-white mb-[50px]">
              Where users become builders. <br />
              Connect with the communities expanding SWITCH across commerce and
              Web3.
            </p>
            <div className="flex flex-row gap-4">
              <div className="flex flex-row gap-4 text-[32px] text-white w-full">
                <a
                  href="https://x.com/protocol_switch"
                  className="hover:opacity-80 transition-opacity"
                >
                  <RiTwitterXLine />
                </a>
                <a
                  href="https://t.me/+VuAllEu7z11jMzk1"
                  className="hover:opacity-80 transition-opacity"
                >
                  <BiLogoTelegram />
                </a>
                <a
                  href="https://medium.com/@switch_protocol"
                  className="hover:opacity-80 transition-opacity"
                >
                  <AiOutlineMedium />
                </a>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-center">
            <div className="w-full h-full flex items-end justify-end lg:items-end lg:justify-end">
              <div className="text-white/50 text-sm w-full lg:w-auto">
                <img
                  src={Image}
                  alt="section9"
                  className="w-full lg:w-auto h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
